//import './App.css';
import Header from './components/Header'
import Index from './components/Index';
import {Routes, Route, BrowserRouter, HashRouter} from 'react-router-dom';
import InoueBingo from './components/Inoue Bingo';
import TakahashiBingo from './components/Takahashi Bingo';
import Error from './components/Error';
import Gradia from './components/Gradia';
import Links from './components/Links';
import Footer from './components/Footer';
import Reviews from './components/Reviews';

function App() {
  return (
    <BrowserRouter basename='/'>
    <div className="App">
      <Header />
        <Routes>
          <Route path="/edsite" element={<Index />} />
          <Route path="/" element={<Index />} />
          <Route path="/bingo" element={<InoueBingo/>} /> 
          <Route path="/takahashi-bingo" element={<TakahashiBingo />} />
          <Route path="/reviews" element={<Reviews />} /> 
          <Route path="/dnd" element={<Gradia />}/>
          <Route path="*" element={<Error />} />
          <Route path="/links" element={<Links />} />
        </Routes>
        <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;
